import { gql } from '@apollo/client';
import { ACTOR_FIELDS_FRAGMENT } from './fragments';

/**
 * Actor GraphQL Queries - 9 queries for Formula #1/#6 support
 */

export const GET_ACTOR = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query GetActor($tenantId: String!, $actorId: String!) {
    getActor(tenantId: $tenantId, actorId: $actorId) {
      ...ActorFields
    }
  }
`;

export const LIST_ACTORS = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query ListActors($tenantId: String!, $limit: Int, $cursor: String) {
    listActors(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...ActorFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

export const GET_ACTORS_BY_TYPE = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query GetActorsByType($tenantId: String!, $actorType: GqlActorType!) {
    getActorsByType(tenantId: $tenantId, actorType: $actorType) {
      ...ActorFields
    }
  }
`;

export const GET_AVAILABLE_ACTORS = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query GetAvailableActors($tenantId: String!) {
    getAvailableActors(tenantId: $tenantId) {
      ...ActorFields
    }
  }
`;

export const GET_ACTORS_BY_TEAM = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query GetActorsByTeam($tenantId: String!, $teamId: String!) {
    getActorsByTeam(tenantId: $tenantId, teamId: $teamId) {
      ...ActorFields
    }
  }
`;

export const GET_ACTORS_BY_CAPABILITY = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query GetActorsByCapability($tenantId: String!, $capability: String!) {
    getActorsByCapability(tenantId: $tenantId, capability: $capability) {
      ...ActorFields
    }
  }
`;

export const GET_ACTOR_STATISTICS = gql`
  query GetActorStatistics($tenantId: String!, $actorId: String!) {
    getActorStatistics(tenantId: $tenantId, actorId: $actorId) {
      actorId
      workload
      maxCapacity
      utilizationPercent
      successRate
      avgTaskResponseMinutes
      circuitBreakerOpen
    }
  }
`;

export const GET_LEAST_LOADED_ACTORS = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query GetLeastLoadedActors($tenantId: String!, $limit: Int) {
    getLeastLoadedActors(tenantId: $tenantId, limit: $limit) {
      ...ActorFields
    }
  }
`;

export const GET_ACTORS_WITH_OPEN_CIRCUIT_BREAKER = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  query GetActorsWithOpenCircuitBreaker($tenantId: String!) {
    getActorsWithOpenCircuitBreaker(tenantId: $tenantId) {
      ...ActorFields
    }
  }
`;
